import { Quote, QuoteStatus } from '~/types/quote';

export const RECEIVER_COMPANY = 'business';
export const RECEIVER_PRIVATE = 'private';
export const PRICE_NET = 'net';
export const PRICE_GROSS = 'gross';
export const YOUR_PRICE = 'your';
export const CUSTOMER_PRICE = 'customer';
export const MAXIMUM_FILE_SIZE = 2 * 1024 * 1024;
export const ROT_VALUE = 0.5;
export const AUTOSAVE_MS_DELAY = 2000;

export const quoteRoutes = ['/mina-offerter/'];
export const quoteEditModeCompatibleRoutesSlugs = ['/produkt', '/search', '/kategorier', '/kampanjer', '/sortiment'];

export const EMPTY_QUOTE: Quote = {
  status: QuoteStatus.draft,
  finalMessage: '',
  validFrom: '',
  validFor: 0,
  sender: {
    name: '',
    organizationNumber: '',
    reference: '',
    address: {
      address: ``,
      postalCode: ``,
      postalAddress: ``,
    },
  },
  receiver: {
    type: RECEIVER_COMPANY,
    label: '',
    name: '',
    contactPerson: '',
    address: {
      address: ``,
      postalCode: ``,
      postalAddress: ``,
    },
  },
  priceType: PRICE_NET,
  items: [],
  mergeArticles: false,
  showDiscounts: false,
  customItems: [],
};
